import * as React from "react";
import styled from "styled-components";

import { Text } from "../../../../components/atoms";
import { Modal } from '../../../themed-v2/molecules/modal';
import { SelectorContainer } from "../../../../containers/common/selector";
import { IAddressSuggestion } from "../../../../services/api/postcodes";

interface IProps {
  isItemsLoading: boolean;
  items: (string | IAddressSuggestion)[];
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onClick(): void;
  onClose(): void;
  onCloseModal(): void;
  onSelect(item: object | string): void;
  trackChange(value: string | undefined): void;
  selectedItem: string;
  showInstructionalInitialMessage: boolean;
  showInstructionalMessage: boolean;
  showNoResults: boolean;
  showUnSupportedPostcodeModal: boolean;
}

const SearchAddressTextMessage = styled(Text)`
  padding: 20px;
`;

const SearchAddress: React.FC<IProps> = (props) => {
  return (
    <React.Fragment>
      <SelectorContainer
        isTyped
        isItemsLoading={props.isItemsLoading}
        itemKey="udprn"
        itemName="suggestion"
        items={props.items}
        placeholder="Postcode or address"
        selectedItem={props.selectedItem}
        onChange={props.onChange}
        onSelect={props.onSelect}
        onClick={props.onClick}
        onClose={props.onClose}
        trackChange={props.trackChange}
      >
        {props.showInstructionalInitialMessage && (
          <SearchAddressTextMessage>
            Type a postcode area or your address
          </SearchAddressTextMessage>
        )}
        {props.showInstructionalMessage && (
          <SearchAddressTextMessage>
            Select a postcode area, or type at least 5 letters to search for an
            address
          </SearchAddressTextMessage>
        )}
        {props.showNoResults && (
          <SearchAddressTextMessage>
            Sorry, we didn't recognise that address. Try starting again with
            your postcode or street name.
          </SearchAddressTextMessage>
        )}
      </SelectorContainer>
      <Modal
        isShow={props.showUnSupportedPostcodeModal}
        onClose={props.onCloseModal}
        isOverlayClose
        modalText="We're sorry! We do not currently serve your postcode."
      />
    </React.Fragment>
  );
};

export { SearchAddress };
